import React, { useState, useContext, useEffect } from 'react';
// import { Form, Dropdown, Input, Grid, Button } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import CreateReminderForm from '../../components/Reminders/CreateReminder';
import ReminderItem from '../../components/Reminders/ReminderItem';

import UserContext from '../../../contexts/UserContext';
import {getReminders, createReminder, deleteReminder, editReminder} from '../../../services/reminders'
import './style.less';

const sendToast = (type = 'warn', message) => {
    if (type === 'success') {
        toast.success(message, {
            position: 'bottom-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
        });
    } else if (type === 'warn') {
        toast.warn(message, {
            position: 'bottom-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
        });
    }
};

const Reminders = () => {
    const loadReminders = async () => {
        // setIsLoading(true);
        const { reminders } = await getReminders(residentId);
        // setIsLoading(false);
        return reminders;
    };

    const { userObject, setUser } = useContext(UserContext);
    const residentId = userObject.registrants.list[userObject.registrants.activeRegistrantsIndexes]._id;
    // const [isLoading, setIsLoading] = useState<boolean>(false);
    const [fetchedReminders, setFetchedReminders] = useState([]);
    type FormData = {
        timestamp: any,
        desc: string,
        frequency: string
    }
    let [formData, setFormData] = useState<FormData>({
        timestamp: null,
        desc: '',
        frequency: ''
    });

    const handleChange = (input, value) => {
        // console.log(input, value);
        setFormData({
            ...formData,
            [input]:value,
        });
    };
    const handleSubmit = async () => {
        // let month = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        // let timestamp = {
        //     day: (new Date(formData.timestamp)).getDate(),
        //     month: month[(new Date(formData.timestamp)).getMonth()],
        //     year: (new Date(formData.timestamp)).getFullYear(),
        //     timeHours: (new Date(formData.timestamp)).getHours(),
        //     timeMinutes: (new Date(formData.timestamp)).getMinutes()
        // }
        // const payload = {
        //     timestamp: timestamp,
        //     desc: String(formData.desc),
        //     frequency: String(formData.frequency)            
        // };
        // const response = await createReminder(residentId, payload);
        // if (response.success) {
        //     sendToast('success', 'Reminder creation requested');
        // }
        //clear form on success
        // setFormData({
        //     timestamp: null,
        //     desc: '',
        //     frequency: ''
        // });
        // const reminders = await loadReminders();
        // setFetchedReminders(reminders);

        ////

        const submittedFormData = JSON.parse(JSON.stringify(formData));
        console.log('submittedData', submittedFormData);
        //clear form to disable duplicate submits
        setFormData({
            timestamp: null,
            desc: '',
            frequency: ''
        });
        const month = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        const timestamp = {
            day: (new Date(submittedFormData.timestamp)).getDate(),
            month: month[(new Date(submittedFormData.timestamp)).getMonth()],
            year: (new Date(submittedFormData.timestamp)).getFullYear(),
            timeHours: (new Date(submittedFormData.timestamp)).getHours(),
            timeMinutes: (new Date(submittedFormData.timestamp)).getMinutes()
        }
        const payload = {
            timestamp: timestamp,
            desc: String(submittedFormData.desc),
            frequency: String(submittedFormData.frequency)            
        };
        const response = await createReminder(residentId, payload);
        if (response.success) {
            sendToast('success', 'Reminder creation requested');
            const reminders = await loadReminders();
            setFetchedReminders(reminders);
        } else {
            sendToast('warn', 'Reminder creation failed');
            setFormData(submittedFormData);
        }
    };
    const handleDuplicate = (reminder) => {
        const timestampToDuplicate = (new Date(`${reminder.timestamp.month} ${reminder.timestamp.day}, ${reminder.timestamp.year} ${reminder.timestamp.timeHours}:${reminder.timestamp.timeMinutes}:00`))
        setFormData({
            timestamp: timestampToDuplicate.getTime() > Date.now() ? timestampToDuplicate : new Date(), //If duplicated reminder is from an earlier time, set duplicated reminder time to now.
            desc: reminder.desc,
            frequency: reminder.frequency
        });
    };
    const handleDelete = async (reminder) => {
      console.log('handleDelete', reminder);
      const response = await deleteReminder(reminder._id);
      if (response.success) {
        sendToast('success', 'Reminder delete requested');
      }
      const reminders = await loadReminders();
      setFetchedReminders(reminders);
    };
    const handleEdit = async (reminderId, reminder) => {
        console.log('sending', reminderId, reminder);
        const response = await editReminder(reminderId, reminder);
        console.log(response);
        if (response.success === true) {
            sendToast('success', 'Reminder update requested');
            const reminders = await loadReminders();
            setFetchedReminders(reminders);
            return true;
        }
        else {
            sendToast('warn', 'Reminder update request failed');
            return false;
        }
    };
    //reminders rejected by resident
    const handleClear = async (reminder)=> {
        // console.log('handleclear', reminder._id, reminder);
        const response = await deleteReminder(reminder._id);
        if (response.success) {
            sendToast('success', 'Reminder cleared');
        }
        const reminders = await loadReminders();
        setFetchedReminders(reminders);
    };

    const {
        userObject: {
            registrants: { list: listOfResidents, activeRegistrantsIndexes },
        },
    } = useContext(UserContext);

    const isDisabledForPayment = activeRegistrantsIndexes[0] === 'all-users' ? false : !(activeRegistrantsIndexes
    .filter(
        (residentIndex) =>
            !listOfResidents[residentIndex].isDisabledForPayment
    ).length)

    useEffect(() => {
        loadReminders().then((reminders)=>{
            setFetchedReminders(reminders);
        });

    },[]);


    return (
        <div className='reminders-page'>
            {isDisabledForPayment ? (
                <div className="no-invites">
                    This user(s) does not have an active Speak2 Family subscription. Please contact their Admin
                    to update their subscription to use Speak2 Family.
                </div>
            ) : (
                <div>
                    <h1>Create reminder</h1>
                    <CreateReminderForm
                        handleSubmit={handleSubmit}
                        handleChange={handleChange}
                        formData={formData}
                        editMode={false}
                    />
                    <hr style={{margin: '20px 0'}} />
                    <h1>View reminders</h1>
                    {fetchedReminders && fetchedReminders.map((reminder)=>
                        <ReminderItem
                            //@ts-ignore
                            key={reminder._id}
                            reminder={reminder}
                            handleDuplicate={handleDuplicate}
                            handleDelete={handleDelete}
                            handleEditSubmit={handleEdit}
                            handleClear={handleClear}
                        />
                    )}
                </div>
            )}
        </div>
    );
};

export default Reminders;